enum EBarcodeValueTypes {
	Constant,
	Dynamic
}

export default EBarcodeValueTypes;
